<template>
  <v-highlight
    :product="product"
    class="c-highlight--hero"
  >
    <h3 class="o-typography__headline1">
      {{ product.title }}
    </h3>
    <p class="o-typography__body1 u-desktop-only">
      {{ product.lead }}
    </p>
  </v-highlight>
</template>
<script>
  import { VHighlight } from '@/index/shared/components';
  import { randomProductMixin } from '@/index/components/section/mixins';

  export default {
    components: {
      VHighlight,
    },
    mixins: [
      randomProductMixin,
    ],
  };
</script>
